import React from 'react'
import _ from 'lodash'
import Moment from "moment"
import { Component } from 'react'
import ReactTable from 'react-table'
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody, ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip
} from 'reactstrap'
import { compose } from 'redux'

import CustomPagination from 'components/Pagination'
import AlertNotSubscribe from 'components/Alert'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import DeleteConfirmationModal from 'components/Modal/deleteConfirmation'
import PageTitle from 'components/Title/PageTitle'
import CreateForm from './Create'
import UpdateForm from './Update'

import Lang from 'Lang/General'
import DuplicateForm from './DuplicateModal'
import WithForms from './actions'
import WithTemplateComponents from './actions/TemplateComponents'
import WithNewsletters from './actions/newsletters'

class Webforms extends Component {
  componentDidMount = () => {
    this.props.getForms({
      filter:{"client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id},
      page: 1,
    })
    let tmpIndex = _.findIndex( this.props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    this.props.onChangeFormsHOC( 'subscribedPackage', tmpIndex > -1 )
  }


  permissionHandle = (context) => {
    let tmp = _.find( this.props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Fair' })
      return this.props.subscribedPackage && tmpModules[ context ]
    }
  }

  getColumnWidth = ( data, headerText ) => {
    let max = 0
    const maxWidth = 400
    const magicSpacing = 18
  
    for ( var i = 0; i < data.length; i++ ) {
      if ( !_.isEmpty( data[ i ][ 'dataLabel' ] ) ) {
        if ( data[ i ][ 'dataLabel' ].length > max ) {
          max = data[ i ][ 'dataLabel' ].length
        }
      }
    }

    return Math.min( maxWidth, Math.max( max, headerText.length ) * magicSpacing )
  }

  renderSubmittedForms = () => (
    <Modal isOpen={ this.props.showSubmittedForms } size='lg'>
      <ModalHeader toggle={ () => this.props.onChangeFormsHOC( 'showSubmittedForms', false ) } >
        { Lang[ 'SUBMITTED_FORMS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }</ModalHeader>
      <ModalBody>
        {
          this.props.submittedForms.map( item => {
            let colWidth = this.getColumnWidth( JSON.parse( item.values ) , Lang[ 'LABEL' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] )
            return <Row className='pb-4' >
              <Col md={ 12 } >
                <ReactTable
                  showPagination={ true }
                  defaultPageSize={ 5 }
                  NoDataComponent={ () => <span></span> }
                  data={ [
                    { dataLabel: `${ Lang[ "SUBMITTED_ON" ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }:`, value: Moment( item.created_at ).format( 'DD.MM.YYYY HH:mm:ss' ) },
                    ... _.filter( JSON.parse( item.values ), formVal => formVal.type !== 'text' && formVal.type !== 'image' ) 
                  ] }
                  columns={[
                    {
                      Header: Lang[ 'LABEL' ][ this.props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: 'dataLabel',
                      width: colWidth
                    },
                    {
                      Header: Lang[ 'VALUE' ][ this.props.data.languageReducer.userSettings.admin_panel_language ],
                      accessor: 'value',
                      Cell: row => typeof row.original.value === 'string' ? (
                        <div style={{ whiteSpace: "pre-line" }}>{row.original.value}</div>
                      ) : ( 
                        <ul style={ { padding: "20px" }}>
                          { 
                            row.original.value.map( item => row.original.type === 'inputFile'
                              ? <li><a style={{ overflow: "hidden" }} href={ item } >{ item }</a></li>
                              : <li>{ item }</li>
                            ) 
                          }
                        </ul>
                      )
                    }
                  ]}
                  getTrProps={ ( state, rowInfo ) => {
                    if ( rowInfo ) {
                      return {
                        style: {
                          background: rowInfo.index < 1 ? "#f8f9fa" : "none"
                        }
                      }
                    }
                    return {}
                  }}
                />
              </Col>
            </Row> 
          })
        }
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => this.props.onChangeFormsHOC( 'showSubmittedForms', false ) }>
          { Lang[ 'CLOSE' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }</Button>
      </ModalFooter>
    </Modal>
  )

  render = () => {
    return (
      <>
        <PageTitle
          heading={ Lang[ 'WEBFORMS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }
          icon="pe-7s-note icon-gradient bg-happy-itmeo"
          buttons={[
            ... this.permissionHandle( 'is_create' ) ? [
              {
                onClick: () => this.props.onChangeFormsHOC( 'showCreateForm', true ),
                display: 'block',
                buttonText: Lang[ 'CREATE_NEW_FORM' ][ this.props.data.languageReducer.userSettings.admin_panel_language ]
              }
            ] : []
          ]} 
        />
        <Container fluid>
          {
            !this.props.subscribedPackage && (
              <AlertNotSubscribe { ...this.props } />
            )
          }
          <Row>
            <Col md={ 12 }>
              <Card className="main-card mb-3">
                <CardBody>
                  <ReactTable
                    NoDataComponent={ () => <span></span> }
                    showPagination={ false }
                    data={ this.props.forms }
                    columns={[
                      {
                        Header: Lang[ 'NAME' ][ this.props.data.languageReducer.userSettings.admin_panel_language ],
                        accessor: 'name',
                        Cell: ({ value }) => value[ this.props.data.languageReducer.userSettings.admin_panel_language ]
                      },
                      {
                        Header: Lang[ 'ACTIONS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ],
                        Cell: ( row ) => {
                          return (
                            <div style={{ display:"block" }}>
                              <Button
                                id={ `Forms-${ row.original.id }-edit` }
                                className="mr-2 mb-2 btn-icon btn-icon-only"
                                color="primary"
                                onClick={() => {
                                  this.props.getSelectedForm( row.original.id, true )
                                }}
                                disabled={ !this.props.subscribedPackage }>
                                <i className="pe-7s-pen btn-icon-wrapper"> </i>
                              </Button>
                              <UncontrolledTooltip
                                target={ `Forms-${ row.original.id }-edit` }
                                placement="top">
                                { Lang[ 'UPDATE_FORM' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }
                              </UncontrolledTooltip>
                              <Button
                                id={ `Forms-${ row.original.id }-duplicate` }
                                className="mr-2 mb-2 btn-icon btn-icon-only"
                                color="primary"
                                onClick={() => {
                                  this.props.getSelectedForm( row.original.id, false )
                                }}
                                disabled={ !this.props.subscribedPackage }>
                                <i className="pe-7s-copy-file btn-icon-wrapper"> </i>
                              </Button>
                              <UncontrolledTooltip
                                target={ `Forms-${ row.original.id }-duplicate` }
                                placement="top">
                                { Lang[ 'DUPLICATE_FORM' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }
                              </UncontrolledTooltip>
                              <Button
                                disabled={ !this.props.subscribedPackage }
                                className="mr-2 mb-2"
                                color="primary"
                                onClick={ () => this.props.getSubmittedForms( row.original.id ) }>
                                { Lang[ 'VIEW_SUBMITTED_DATA' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }
                              </Button>
                              {
                                this.permissionHandle( 'is_delete' ) && (
                                  <>
                                    <Button
                                      disabled={ !this.props.subscribedPackage }
                                      id={ `Forms-${ row.original.id }-delete` }
                                      className='mb-2 mr-2 btn-icon btn-icon-only'
                                      color='danger'
                                      onClick={ () =>  {
                                        Promise.all([
                                          this.props.onChangeFormsHOC( 'selectedForm', row.original ) 
                                        ]).then(
                                          this.props.onChangeFormsHOC( 'showConfirmDeleteModal', true )
                                        )
                                      }}>
                                      <i className='pe-7s-trash'> </i>
                                    </Button>
                                    <UncontrolledTooltip
                                      target={ `Forms-${ row.original.id }-delete` }
                                      placement='top'>
                                        { Lang[ 'DELETE' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }
                                    </UncontrolledTooltip>
                                  </>
                                )
                              }
                            </div>
                          )
                        }
                      }
                    ]} />
                   <CustomPagination
                    meta={this.props.formMeta}
                    onChangePage={ val => {
                      this.props.getForms({
                        filter:{"client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id},
                        page: val,
                      })
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <CreateForm 
          { ...this.props } 
          selectedLanguage={ this.props.data.languageReducer.userSettings.admin_panel_language}
          siteSettings={{
            primary_color: 'red',
            secondary_color: 'blue',
          }}
        
        />
        <UpdateForm 
          { ...this.props } 
          selectedLanguage={ this.props.data.languageReducer.userSettings.admin_panel_language}
          siteSettings={{
            primary_color: 'red',
            secondary_color: 'blue',
          }}

        />
        <DuplicateForm 
          { ...this.props } 
          selectedLanguage={ this.props.data.languageReducer.userSettings.admin_panel_language}
        />
        { this.renderSubmittedForms() }
        {
          this.props.showConfirmDeleteModal && (
            <DeleteConfirmationModal
              handleModalClose={ () => this.props.onChangeFormsHOC( 'showConfirmDeleteModal', false ) }
              confirmAction={ () => {
                this.props.deleteForm( this.props.selectedForm.id )
              }}
              content={ Lang[ 'ARE_YOU_SURE_TO_DELETE_FORM' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] }
              lang={ this.props.data.languageReducer.userSettings.admin_panel_language } 
            />
          )
        }
        { 
          ( 
            this.props.onLoadForms || 
            this.props.onLoadFormLogs || 
            this.props.onLoadNewslettersHOC
          ) && <LoadingOverlay /> 
        }
      </>
    )
  }
}

export default compose(
  WithNewsletters,
  WithForms,
  WithTemplateComponents
)( Webforms )